import { Pipe, PipeTransform } from '@angular/core';

function fixToTwoDigits(val) {
  return val < 10 ? `0${val}` : val;
}

@Pipe({ name: 'hosDuration' })
export class HosDurationPipe implements PipeTransform {
  public transform(duration: number, showSeconds: boolean = false) {
    const hour = Math.floor(duration / (60 * 60));
    const min = Math.floor((duration / 60)) % 60;
    if (showSeconds) {
      const sec = Math.floor((duration)) % 60;
      return `${fixToTwoDigits(hour)}:${fixToTwoDigits(min)}:${fixToTwoDigits(sec)}`;
    }
    return `${fixToTwoDigits(hour)}:${fixToTwoDigits(min)}`;
  }
}
